import * as PIXI from 'pixi.js';
import KTween from '../core/KTween';
import EventDispatcher from '../core/EventDispatcher';

const TO_RAD = Math.PI / 180;
const TO_DEG = 180 / Math.PI;
const ANGLE = 30;

export class LineAnimation extends PIXI.Container
{
	left;
	right;
	tl:PIXI.Sprite;
	tr:PIXI.Sprite;
	bl:PIXI.Sprite;
	br:PIXI.Sprite;

	_leftIn = 0;
	_leftOpen = 0;
	_rightIn = 0;
	_rightOpen = 0;

	private _renderTimeout;

	constructor()
	{
		super();

		let s = Math.cos(ANGLE * TO_RAD) / Math.sin(ANGLE * TO_RAD);


		this.left = new PIXI.Container();
		this.right = new PIXI.Container();
		this.left.skew.y = 30 * TO_RAD;
		this.left.scale.x = -1 * s;
		this.left.scale.y = s;
		this.right.skew.y = -30 * TO_RAD;
		this.right.scale.x = s;
		this.right.scale.y = s;

		this.tl = new PIXI.Sprite(PIXI.Texture.WHITE);
		this.tl.scale.y = -1;
		this.tr = new PIXI.Sprite(PIXI.Texture.WHITE);
		this.tr.scale.y = -1;
		this.bl = new PIXI.Sprite(PIXI.Texture.WHITE);
		this.br = new PIXI.Sprite(PIXI.Texture.WHITE);

		this.tl.tint = 0xDDDDDD;
		this.bl.tint = 0xDDDDDD;

		this.tr.tint = 0xEEEEEE;
		this.br.tint = 0xEEEEEE;

		this.left.addChild(this.tl);
		this.left.addChild(this.bl);
		this.right.addChild(this.tr);
		this.right.addChild(this.br);
		this.addChild(this.left);
		this.addChild(this.right);
	}

	redraw()
	{
		clearTimeout(this._renderTimeout);
		this._renderTimeout = setTimeout(this._redraw, 0);
	}

	_redraw = () =>
	{
		let ww = window.innerWidth;
		let wh = window.innerHeight;
		let v;

		this.left.x = ww * 0.5;
		this.left.y = wh * 0.75;
		this.right.x = ww * 0.5;
		this.right.y = wh * 0.75;

		this.tl.x = -(1 - this._leftIn) * ww * 0.1;
		this.bl.x = -(1 - this._leftIn) * ww * 0.1;
		this.tl.width = this._leftIn * ww * 0.5;
		this.bl.width = this._leftIn * ww * 0.5;

		let c = (this._leftIn * 0xDD) >> 0;
		c = c << 16 | c << 8 | c;
		this.tl.tint = c;
		this.bl.tint = c;

		c = (this._rightIn * 0xEE) >> 0;
		c = c << 16 | c << 8 | c;
		this.tr.tint = c;
		this.br.tint = c;

		this.tr.x = -(1 - this._rightIn) * ww * 0.1;
		this.br.x = -(1 - this._rightIn) * ww * 0.1;
		this.tr.width = this._rightIn * ww * 0.5;
		this.br.width = this._rightIn * ww * 0.5;

		if(this._leftOpen < 1)
		{
			this.tl.y = 0;
			this.bl.y = 0;
			this.tl.height = this._leftOpen * wh + 1;
			this.bl.height = this._leftOpen * wh;
		}else
		{
			v = this._leftOpen - 1;
			this.tl.height = (1 - v) * wh + 1;
			this.tl.y = -v * wh;
			this.bl.height = (1 - v) * wh + 1;
			this.bl.y = v * wh;
		}

		if(this._rightOpen < 1)
		{
			this.tr.y = 0;
			this.br.y = 0;
			this.tr.height = this._rightOpen * wh + 1;
			this.br.height = this._rightOpen * wh;
		}else
		{
			v = this._rightOpen - 1;
			this.tr.height = (1 - v) * wh + 1;
			this.tr.y = -v * wh;
			this.br.height = (1 - v) * wh + 1;
			this.br.y = v * wh;
		}
	}


	get leftIn(){
		return this._leftIn;
	}

	set leftIn(value){
		if(value == this._leftIn) return;
		this._leftIn = value;
		this.redraw();
	}

	get leftOpen(){
		return this._leftOpen;
	}

	set leftOpen(value){
		if(value == this._leftOpen) return;
		this._leftOpen = value;
		this.redraw();
	}

	get rightIn(){
		return this._rightIn;
	}

	set rightIn(value){
		if(value == this._rightIn) return;
		this._rightIn = value;
		this.redraw();

	}

	get rightOpen(){
		return this._rightOpen;
	}

	set rightOpen(value){
		if(value == this._rightOpen) return;
		this._rightOpen = value;
		this.redraw();

	}

	transitionIn(callback = null)
	{
		this.leftIn = 1;
		this.rightIn = 1;
		this.leftOpen = 1;
		this.rightOpen = 1;
		KTween.tween(this, {leftOpen: 2, rightOpen: 2, onComplete: callback}, 'easeInCirc', 0.4);
	}

	transitionOut(callback = null)
	{
		this.leftIn = 0;
		this.rightIn = 0;
		this.leftOpen = 0;
		this.rightOpen = 0;
		KTween.tween(this, {leftIn: 1}, 'easeOutQuart', 0.4);
		KTween.tween(this, {rightIn: 1}, 'easeOutQuart', 0.4, 0.1);
		KTween.tween(this, {leftOpen: 1, rightOpen: 1, onComplete: callback}, 'easeInCirc', 0.4, 0.5);
	}
}